import React from "react";
import { useTranslation } from "react-i18next";
import Card from "../generic/Card";

function ChinWooOverview() {
  const { t } = useTranslation();

  const infoCards = [
    {
      id: "detail1",
      icon: "fas fa-globe",
      title: t("chinwooOverview.details.detail1.subtitle"),
      description: t("chinwooOverview.details.detail1.text"),
    },
    {
      id: "detail2",
      icon: "fas fa-leaf",
      title: t("chinwooOverview.details.detail2.subtitle"),
      description: t("chinwooOverview.details.detail2.text"),
    },
    {
      id: "detail3",
      icon: "fas fa-dove",
      title: t("chinwooOverview.details.detail3.subtitle"),
      description: t("chinwooOverview.details.detail3.text"),
    },
    {
      id: "detail4",
      icon: "fas fa-users",
      title: t("chinwooOverview.details.detail4.subtitle"),
      description: t("chinwooOverview.details.detail4.text"),
    },
  ];

  return (
    <section
      className="relative z-10 bg-slate-50/50 pb-14 pt-24 transition-colors dark:bg-slate-900 md:pb-16"
      id="chinwoo-overview"
      aria-labelledby="chinwoo-overview-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="chinwoo-overview-heading"
            className="relative mb-5 inline-block text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl"
          >
            {t("chinwooOverview.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
              aria-hidden
            />
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-pretty text-lg leading-relaxed text-slate-600 dark:text-slate-400">
            {t("chinwooOverview.description")}
          </p>
        </header>

        <ul className="m-0 grid list-none grid-cols-1 gap-5 p-0 sm:grid-cols-2 md:gap-6 xl:grid-cols-4">
          {infoCards.map((card) => (
            <li key={card.id} className="min-h-0">
              <Card
                icon={card.icon}
                title={card.title}
                description={card.description}
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default ChinWooOverview;
